import eventMixin from '../lib/mixins/event';
import Logger from '../lib/logger';
import Player from '@vimeo/player';
import { v4 as uuidv4 } from 'uuid';

export default class ThemeVideoContentModule {

    constructor(dom) {

        // Vars
        // ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒
        this.NAME = `ThemeVideoContentModule`;
        this.videoDom = dom.querySelector('[data-theme-video-content-module-video]');

        const uuid = uuidv4();
        this.videoDom.setAttribute('id', uuid);

        this.playButtonDom = dom.querySelector('theme-play-button');

        this.vimeoId = this.videoDom?.getAttribute('data-theme-video-content-module-video');
        this.videoPlayer = null;
    }

    // Logic
    // ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒
    init() {
        Logger.info(`${this.NAME} > init`);

        const self = this;

        /**
        * Initialize the Vimeo Player when visible
        */
        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                const intersecting = entry.isIntersecting;

                if (intersecting && !this.videoPlayer) {
                    self.initializeVideoPlayer();
                }
            })
        })

        observer.observe(this.videoDom);

    }

    hidePlayButton() {
        Logger.info(`${this.NAME} > hidePlayButton`);
        this.playButtonDom.dataset.playing = 'true';
    }

    initializeVideoPlayer() {
        Logger.info(`${this.NAME} > initializeVideoPlayer`);

        const self = this;

        this.videoPlayer = new Player(this.videoDom.getAttribute('id'), {
            id: this.vimeoId,
            controls: true,
            title: false,
        });

        // Listen for ended
        this.videoPlayer.on('ended', function () {
            self.showPlayButton();
            this.videoPlayer.setCurrentTime(0);
        });

        // Listen for play
        this.videoPlayer.on('play', function () {
            self.hidePlayButton();
        });

        // Listen for pause
        this.videoPlayer.on('pause', function () {
            self.showPlayButton();
        });

        this.playButtonDom.addEventListener('click', (e) => {
            e.preventDefault();
            const isPaused = this.videoPlayer.getPaused().then((isPaused) => {
                if (isPaused) {
                    self.playVideo();
                } else {
                    self.pauseVideo()
                }
            });
        });
    }

    playVideo() {
        Logger.info(`${this.NAME} > playVideo`);
        this.videoPlayer?.play();
    }

    pauseVideo() {
        Logger.info(`${this.NAME} > pauseVideo`);
        this.videoPlayer?.pause();
    }

    showPlayButton() {
        Logger.info(`${this.NAME} > showPlayButton`);
        this.playButtonDom.dataset.playing = 'false';
    }
}

// Mixins
Object.assign(ThemeVideoContentModule.prototype, eventMixin);
